import { Box, Typography } from '@mui/material';
import React from 'react';
import { SingleChoiceWithTextAggregation as SingleChoiceWithTextAggregationType } from '../../redux/types';
import { FormattedAggregatedResultSingleChoiceWithText } from './FormattedResult';

type Props = {
  data: SingleChoiceWithTextAggregationType;
}

const SingleChoiceWithTextAggregation: React.FC<Props> = ({
  data,
}: Props) => (
  <Box>
    {
      Object.entries(data.payload).map(([key, val]) => {
        const {
          correct, inputs, text, count, reviewCount,
        } = val;
        return (
          <Box key={key} sx={{ my: '0.8rem' }}>
            <FormattedAggregatedResultSingleChoiceWithText
              reviewCount={reviewCount}
              text={text}
              total={count}
              correct={correct}
            />
            {
              inputs && Object.keys(inputs).length > 0 && (
                <Box>
                  <Typography variant="body2" color="grey.500" component="span">
                    [
                    {
                      Object.entries(inputs).map(([key2, val2]) => (
                        <Typography key={key2} variant="body2" color="grey.500" component="div">
                          {`${key2}×${val2}`}
                        </Typography>
                      ))
                    }
                    ]
                  </Typography>
                </Box>
              )
            }
          </Box>
        );
      })
    }
  </Box>
);

export default SingleChoiceWithTextAggregation;
